import React from "react";
import moment from "moment";
import { baseUrl } from "../../../utils/constants";
import { GiOpenTreasureChest } from "react-icons/gi";
import { useState } from "react";
import TrivvyLinkedRewardsDetailsModal from "./TrivvyLinkedRewardsDetailsModal";

export default function WrapLinkedRewards({
  rewards,
  quizPage,
  showLinkedTrivvys,
  currentTrivvy,
}) {
  const [linkedRewardsModal, setLinkedRewardsModal] = useState(false);
  if (showLinkedTrivvys) {
    return (
      <ul
        style={{
          width: "100%",
          listStyle: "bullets",
          maxHeight: quizPage ? "300px" : "100px",
          overflowX: "hidden",
          overflowY: "auto",
        }}
        className="hide-scroll"
      >
        {rewards.map((x) => {
          const rewardTrivvys =
            currentTrivvy && currentTrivvy._id
              ? x.linkedTrivias.filter((x) => x.triviaId != currentTrivvy._id)
              : x.linkedTrivias;
          return (
            <li>
              {x.rewardName} -{" "}
              {x.rewardTemplateId && !x.rewardDescription
                ? x.rewardTemplateId.description
                : x.rewardDescription}
              {moment().isSameOrBefore(moment(x.rewardDate)) ? (
                ""
              ) : (
                <span className="text-danger font-11px">
                  The reward has been closed and you are no longer eligible for
                  the reward.
                </span>
              )}
              {showLinkedTrivvys && rewardTrivvys.length && currentTrivvy ? (
                <div>
                  <div>Other trivvys for the reward</div>

                  <ol>
                    {rewardTrivvys.map((rt) => {
                      return (
                        <li
                          className="cursor-pointer link"
                          onClick={() => {
                            window.open(
                              `${baseUrl()}home/trivia/${
                                currentTrivvy.organizationId
                              }/quiz/${rt.triviaId}/start`
                            );
                          }}
                        >
                          <span className="trivvy-linktext">
                            {" "}
                            {rt.triviaName}
                          </span>
                        </li>
                      );
                    })}
                  </ol>
                </div>
              ) : (
                ""
              )}
            </li>
          );
        })}
      </ul>
    );
  } else if (rewards && rewards.length > 0) {
    return (
      <div>
        {
          linkedRewardsModal &&  <TrivvyLinkedRewardsDetailsModal
          open={linkedRewardsModal}
          modalData={rewards}
          onClose={() => {
            setLinkedRewardsModal(false);
          }}
          showExpiry
        />
        }
       
        {rewards && rewards.length == 1 ? (
          <div>
            <div>
              {rewards.map((x) => {
                return (
                  <div>
                    <GiOpenTreasureChest className="mr-1" /> {x.rewardName}
                    {moment().isSameOrBefore(moment(x.rewardDate)) ? (
                      ""
                    ) : (
                      <span className="text-danger ml-2 font-11px">
                        The reward has been closed and you are no longer
                        eligible for the reward.
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div>
            <span
              onClick={() => setLinkedRewardsModal(true)}
              className="wp-link-text"
            >
              See linked rewards
            </span>
          </div>
        )}
      </div>
    );
  }
}
